// Common short URL: /seo → /local-seo (301).
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/seo")({
  beforeLoad: () => {
    throw redirect({ to: "/local-seo", statusCode: 301 });
  },
});
